import { render } from "./CreatePermissionModal.vue?vue&type=template&id=97af7730&scoped=true"
import script from "./CreatePermissionModal.vue?vue&type=script&lang=js"
export * from "./CreatePermissionModal.vue?vue&type=script&lang=js"

import "./CreatePermissionModal.vue?vue&type=style&index=0&id=97af7730&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97af7730"]])

export default __exports__